import React from "react"
import Header from "./Header"
import Footer from "./Footer"
import Figure1 from '../images/figure1.svg';
import Figure2 from '../images/figure2.svg';
import Figure3 from '../images/figure3.svg';
import Figure4 from '../images/figure4.svg';



 
export default function Hero({ frontpageObject, children, image, showTitle = true, leftImage = false }) {

  return(
    <div className="wrap">
      <img src={Figure1} className="figure-abs1 figure-abs1_main"></img>
      <img src={Figure2} className="figure-abs2 figure-abs2_main"></img>
      <img src={Figure3} className="figure-abs3 figure-abs3_main"></img>
      <img src={Figure4} className="figure-abs4 figure-abs4_main"></img>


			<div className="main main_pad">
				<section className="main-section" >
					<img src={image} alt="main_img" className="img-abs" />

					<div className={showTitle ? "main-section__box" : "main-section__box main-section__box_noTitle"}>

            { <Header small={true} smallTitle={true} leftImage={leftImage} frontpageObject={frontpageObject} showTitle={showTitle} />}

            {children}

					</div>
				</section>
			</div>
      <Footer />
    </div>
  )
}
